<template>
    <div class="row g-3">
        <!-- NAGŁÓWEK ZAKŁADKI -->
        <div class="col-12 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 border-bottom pb-2 mb-2">
            <div>
                <h6 class="fw-bold mb-0">Kody śledzące i analityczne</h6>
                <small class="text-muted">Skrypty Google Analytics, Facebook Pixel i inne zewnętrzne kody JS</small>
            </div>
            <button
                type="button"
                class="btn btn-primary-dark d-flex align-items-center gap-2"
                :disabled="loading || saving"
                @click="saveData">
                <i class="bi bi-floppy"></i>
                <span>Zapisz zmiany</span>
            </button>
        </div>

        <!-- POLE HEAD -->
        <div class="col-12">
            <label class="form-label fw-semibold">Skrypty wklejane w sekcji &lt;head&gt;</label>
            <textarea
                class="form-control font-monospace"
                rows="6"
                v-model="form.headScript"
                :disabled="loading"
                placeholder="<script>
  // Kod wklejany przed </head>
</script>"></textarea>
            <div class="form-text">Kod zostanie wstrzyknięty tuż przed zamknięciem znacznika <code>&lt;/head&gt;</code>.</div>
        </div>

        <!-- POLE BODY -->
        <div class="col-12 mt-3">
            <label class="form-label fw-semibold">Skrypty wklejane po otwarciu &lt;body&gt;</label>
            <textarea
                class="form-control font-monospace"
                rows="6"
                v-model="form.bodyScript"
                :disabled="loading"
                placeholder="<script>
  // Kod wklejany tuż po <body>
</script>"></textarea>
            <div class="form-text">Kod zostanie wstrzyknięty bezpośrednio po otwarciu znacznika <code>&lt;body&gt;</code>.</div>
        </div>

        <!-- DOLNY PRZYCISK ZAPISU -->
        <div class="col-12 d-flex justify-content-end mt-4 pt-3 border-top">
            <button
                type="button"
                class="btn btn-primary-dark d-flex align-items-center gap-2"
                :disabled="loading || saving"
                @click="saveData">
                <i class="bi bi-floppy"></i>
                <span>Zapisz zmiany</span>
            </button>
        </div>
    </div>

    <!-- LOADER -->
    <AppLoader :show="loading || saving" :text="loaderText" />

</template>

<script setup>
import { ref, onMounted } from 'vue'
import apiClient from '@/api'
import AppLoader from '@/components/AppLoader.vue'
import { webAlert } from '@/utils/dialog'


const loading = ref(false)
const saving = ref(false)
const loaderText = ref('')

const form = ref({
    headScript: '',
    bodyScript: ''
})

const loadData = async () => {
    loading.value = true
    loaderText.value = 'Pobieranie kodów śledzących...'

    try {
        const response = await apiClient.post(
            { action: 'get-settings-ownjs' },
        )

        if (response.data?.data) {
            form.value.headScript = response.data.data.headScript || ''
            form.value.bodyScript = response.data.data.bodyScript || ''
        }

    } catch (error) {
        webAlert('Błąd podczas pobierania kodów śledzących.')
    } finally {
        loading.value = false
    }
}

const saveData = async () => {
    saving.value = true
    loaderText.value = 'Zapisywanie kodów śledzących...'

    try {
        const response = await apiClient.post(
            {
                action: 'save-settings-ownjs',
                headScript: form.value.headScript,
                bodyScript: form.value.bodyScript
            }
        )

        saving.value=false;
        webAlert(response.data)
    } catch (error) {
        saving.value=false;
        webAlert('Błąd podczas zapisywania kodów śledzących.')
    } finally {
        saving.value = false
    }
}

onMounted(() => {
    loadData()
})
</script>

<style scoped>
.font-monospace {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 0.875rem;
}
</style>